import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService } from '../services/data.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {
  @ViewChild('notificationModal', { static: false }) notificationModal: ModalDirective;
  notifications: any[] = [];
  notificationData: any = {};
  isEditing = false;
  currentId: number;
  notificationDataend_date:any;

  public singlePicker = {
    singleDatePicker: true,
    autoUpdateInput: true,
    showDropdowns: true,
    autoApply: true,
    drops: 'bottom',
    locale: {
      format: 'DD MMM YYYY'
    }
  };

  constructor(
    private dataService: DataService,
    private datepipe: DatePipe
  ) { }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.dataService.getSystemNotifications().subscribe(
      (response: any) => {
        this.notifications = response.data;
      }
    );
  }

  selectedDatepicker($event, type) {
    if(type == 'from') {
      this.notificationData.start_date = this.datepipe.transform($event.start, 'MMM d, y');
    } else {
      this.notificationData.end_date = this.datepipe.transform($event.end, 'MMM d, y');
    }
    
  }

  openModal() {
    this.isEditing = false;
    this.notificationData = {
      title: '',
      content: '',
      start_date: '',
      end_date: '',
      status: 'active',
      type: 'maintenance',
    };
    this.notificationModal.show();
  }

  editItem(item: any) {
    this.isEditing = true;
    this.currentId = item.id;
    this.notificationData = {
      title: item.title,
      content: item.content,
      start_date: item.start_time || item.start_date,
      end_date: item.end_time || item.end_date,
      status: item.status,
      type: item.type,
      display_type: item.display_type
    };
    this.notificationModal.show();
  }

  onSubmit() {
    const data = this.notificationData;
    data.start_date = this.datepipe.transform(data.start_date, 'y-MM-d');
    data.end_date = this.datepipe.transform(data.end_date, 'y-MM-d');
    if (this.isEditing) {
      this.dataService.updateSystemNotification(this.currentId, data).subscribe(
        () => {
          this.loadData();
          this.notificationModal.hide();
        }
      );
    } else {
      this.dataService.createSystemNotification(data).subscribe(
        () => {
          this.loadData();
          this.notificationModal.hide();
        }
      );
    }
  }

  deleteItem(id: number) {
    if (confirm('Are you sure you want to delete this notification?')) {
      this.dataService.deleteSystemNotification(id).subscribe(
        () => {
          this.loadData();
        }
      );
    }
  }
}
 